import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const settingsPageLayoutDivStyle1 = css`
  height: 100%;
  overflow-y: auto;
  background-color: ${theme.colors.neutral5};
`;

export const SettingsPageLayoutStyles = {
  settingsPageLayoutDivStyle1,
};
